export const INVOICE_STATUS = [
  {
    id: 6,
    text: 'e_invoice_total_draft',
    styles: 'status-draft',
    totalFieldName: 'TotalDraft',
    isShow: true,
  },
  {
    id: 0,
    text: 'e_invoice_total_original',
    styles: 'status-original',
    totalFieldName: 'TotalOriginal',
    isShow: true,
  },
  {
    id: 3,
    text: 'e_invoice_total_adjustment',
    styles: 'status-adjustment',
    totalFieldName: 'TotalAdjustment',
    isShow: true,
  },
  {
    id: 1,
    text: 'e_invoice_total_replacement',
    styles: 'status-replacement',
    totalFieldName: 'TotalReplacement',
    isShow: true,
  },
  {
    id: 4,
    text: 'e_invoice_total_adjusted',
    styles: 'status-adjusted',
    totalFieldName: 'TotalAdjusted',
    isShow: true,
  },
  {
    id: 2,
    text: 'e_invoice_total_replaced',
    styles: 'status-replaced',
    totalFieldName: 'TotalReplaced',
    isShow: true,
  },
  {
    id: 5,
    text: 'e_invoice_total_canceled',
    styles: 'status-canceled',
    totalFieldName: 'TotalCanceled',
    isShow: false,
  },
]

export const INVOICE_STATUS_CODE = {
  ORIGINAL: 0,
  REPLACEMENT: 1,
  REPLACED: 2,
  ADJUSTMENT: 3,
  ADJUSTED: 4,
  CANCELED: 5,
  DRAFT: 6,
}

export const TAX_AUTHORITY_STATUS = [
  {
    id: 0,
    text: 'einvoice_unsent',
    styles: 'status-replacement'
  },
  {
    id: 1,
    text: 'einvoice_sent',
    styles: 'status-original'
  },
  {
    id: 2,
    text: 'einvoice_valid',
    styles: 'status-adjustment'
  },
  {
    id: 3,
    text: 'einvoice_invalid',
    styles: 'status-replaced'
  },
  {
    id: 4,
    text: 'einvoice_unsent',
    styles: 'status-replacement'
  },
  {
    id: 5,
    text: 'einvoice_sent',
    styles: 'status-original'
  },
  {
    id: 6,
    text: 'einvoice_waitting_code',
    styles: 'status-draft'
  },
  {
    id: 7,
    text: 'einvoice_send_error',
    styles: 'status-replaced'
  },
  {
    id: 8,
    text: 'einvoice_assigned_code',
    styles: 'status-adjusted'
  },
  {
    id: 9,
    text: 'einvoice_code_denied',
    styles: 'status-canceled'
  },
]